import React from 'react';

function Reservation({ setIsPopupOpen }) {
  return (
    <section className="reservation wrap" id="hash-reservation">
      <div className="content">
        <pre lang="en">{`Shared Designer’s Lab
         Reserve facilities`}</pre>
        <button
          type="button"
          className="btn"
          onClick={() => setIsPopupOpen(true)}
        >
          {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            width="72.718"
            height="66.81"
            viewBox="0 0 72.718 66.81"
          >
            <g id="icon-arrow" transform="translate(3.5)">
              <g id="Group-7">
                <path
                  id="Stroke-1"
                  d="M0,0V41.358H64.334"
                  fill="none"
                  stroke="#fff"
                  stroke-width="7"
                  fill-rule="evenodd"
                />
                <path
                  id="Stroke-5"
                  d="M8.5,4,31.477,26.977,8.5,49.953"
                  transform="translate(32.791 14.381)"
                  fill="none"
                  stroke="#fff"
                  stroke-width="7"
                  fill-rule="evenodd"
                />
              </g>
            </g>
          </svg> */}
          예약하기
        </button>
      </div>
    </section>
  );
}

export default Reservation;
